import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ImageItem } from '../image-list-modal/image-list-modal.component';

@Component({
  selector: 'app-image-viewer-modal',
  templateUrl: './image-viewer-modal.component.html',
  styleUrls: ['./image-viewer-modal.component.css'],
  standalone: false
})
export class ImageViewerModalComponent {
  @Input() imageUrl: string = '';
  @Input() imageTitle: string = 'Image';
  @Input() images: ImageItem[] = [];
  @Input() currentIndex: number = 0;

  originalImageUrl: string = '';
  isLoading: boolean = true;
  hasError: boolean = false;
  imageTypeLabel: string = '';

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    if (this.images.length > 0 && this.currentIndex >= 0) {
      this.loadImage(this.images[this.currentIndex]);
    }
  }

  onImageLoad(): void {
    this.isLoading = false;
    this.hasError = false;
  }

  onImageError(): void {
    this.isLoading = false;
    this.hasError = true;
    console.error('Failed to load image:', this.imageUrl);
  }

  downloadImage(): void {
    try {
      const link = document.createElement('a');
      link.href = this.originalImageUrl;
      link.download = this.imageTitle || 'image';
      link.target = '_blank';
      link.rel = 'noopener noreferrer';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Download failed:', error);
    }
  }

  closeModal(): void {
    this.activeModal.dismiss();
  }

  previousImage(event: Event): void {
    event.stopPropagation();
    if (this.canNavigatePrevious) {
      this.currentIndex--;
      this.loadImage(this.images[this.currentIndex]);
    }
  }

  nextImage(event: Event): void {
    event.stopPropagation();
    if (this.canNavigateNext) {
      this.currentIndex++;
      this.loadImage(this.images[this.currentIndex]);
    }
  }

  private loadImage(image: ImageItem): void {
    this.isLoading = true;
    this.hasError = false;
    this.imageUrl = image.largeUrl ?? '';
    this.originalImageUrl = image.originalUrl?.replace('.html', '.jpg') ?? '';

    switch (image.typeLabel) {
      case 'Panoramic':
        this.imageTypeLabel = 'Panoramic';
        break;
      case 'Cover Image':
        this.imageTypeLabel = 'Cover Image';
        break;
      case 'License Document':
        this.imageTypeLabel = 'License Document';
        break;
      case 'Logo':
      case 'Logo Image':
        this.imageTypeLabel = 'Logo';
        break;
      case 'Clinic Images':
        this.imageTypeLabel = 'Clinic Images';
        break;
      default:
        this.imageTypeLabel = 'Other Images';
        break;
    }
  }
  get canNavigatePrevious(): boolean {
    return this.images && this.images.length > 1 && this.currentIndex > 0;
  }

  get canNavigateNext(): boolean {
    return (
      this.images &&
      this.images.length > 1 &&
      this.currentIndex < this.images.length - 1
    );
  }
}